import { render, staticRenderFns } from "./phones.vue?vue&type=template&id=b6a1597e&"
import script from "./phones.vue?vue&type=script&lang=js&"
export * from "./phones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports